import React, { useEffect, useState } from "react";
import './driveContextualMenu.css'
import FileUploadMenu from "./fileUploadMenu/FileUploadMenu";
import UserSizeData from "./userSizeData/userSizeData";
import auth from "../../../utils/authentication";
import { useLocation } from "react-router-dom";

function DriveContextualMenu() {

    const [inMyDrive, setInMyDrive] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const pathname = location.pathname;
        // Assuming you have a way to get the current user.
        const currentUser = auth.currentUser;

        // Update the state based on the conditions.
        setInMyDrive(pathname.includes('my-drive') && !!currentUser);
    }, [location.pathname, auth.currentUser]); // Include dependencies in the array.

    return (
        <div className={"col-12 d-flex justify-content-end flex-column " + (inMyDrive ? "driveContextualMenu__InDriveMenu" : "")}
            style={{ userSelect: "none" }}>
            <FileUploadMenu inMyDrive={inMyDrive} />
            <div className="col-12 d-flex mt-auto" style={{
                marginBottom: inMyDrive ? 50 : 0
            }}>
                {inMyDrive && <UserSizeData />}
            </div>
        </div>
    )
}

export default DriveContextualMenu;
